import React from "react";
import { PrintRecord } from "../../../BlakeData/Types";
// import { API } from "../../../BlakeData";

/**
 * Show a print by itself (not with a second image as a comparison)
 * @param props 
 */
export default function SingleImagePreview(props: {
    print: PrintRecord;
    imageURL: string;
}) {

    return (
        <img alt={props.print.id} style={{
            // maxHeight: "100%",
            // maxWidth: "100%"
            width: "100%"
        }}
            // src={API.getImageURL100(props.print)}
            src={props.imageURL}
        />
    )
}